export default "__VITE_ASSET__DScgXPc8__"